import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { usePermission, useTranslation } from 'hooks';
import { BoardingStage } from 'types/BoardingStage';
import RpcTypes from 'constants/rpcTypes';
import Button from 'components/ui/button';
import bannerImage from './images/form-continue.svg';

const statusesToDisplayBanner: BoardingStage[] = ['onboarding_fill'];

export const MainBanner: FC = () => {
  const getTranslate = useTranslation();
  const history = useHistory();
  const { user } = useSelector((state: RootState) => state);

  const { isEnabled } = usePermission();
  const { activeLegalEntities } = useSelector((state: RootState) => state.user);
  const inProgressLegalEntity = activeLegalEntities.find(
    ({ boarding_status }) => statusesToDisplayBanner.includes(boarding_status)
  );

  if (!isEnabled(RpcTypes.Onboarding_Business_Docs) || !inProgressLegalEntity) {
    return null;
  }

  return (
    <div className='max-tablet:p-0 max-tablet:m-0 mt-6 px-4'>
      <div className='bg-banner-primary max-desktop-s:max-w-[834px] max-desktop-s:flex max-desktop-s:justify-between max-desktop-s:gap-2 max-tablet:p-4 max-tablet:rounded-[unset] relative mx-auto w-full max-w-[1200px] overflow-hidden rounded-(--component-card-border-radius) px-[30px] py-5'>
        <div className='max-desktop-s:flex max-desktop-s:flex-col max-desktop-s:justify-between max-tablet:flex-row max-tablet:items-center max-tablet:gap-6 max-tablet:max-w-none max-mobile-s:flex-col max-mobile-s:gap-[10px] max-w-[665px]'>
          <div>
            <h2 className='text-text-always-white font-heading text-heading-m max-mobile-s:text-m-bold max-mobile-s:mb-1 mb-2 leading-[30px]'>
              {getTranslate('getStarted.DAFIsReady.label')}
            </h2>
            <p className='text-text-always-white text-l-regular max-tablet:text-sm-regular max-tablet:m-0 max-tablet:leading-[19px] mb-4 leading-[140%]'>
              {getTranslate('getStarted.DAFIsReady.text')}
            </p>
          </div>
          <Button
            customClass='max-tablet:shrink-0 max-mobile-s:w-[100%] w-fit'
            status='light'
            text={getTranslate('getStarted.agreeActivate.button')}
            onClick={() =>
              history.push(
                user.isAccessToOnboardingForm
                  ? '/merchant-onboarding'
                  : '/maf?legalEntityId=' + legalEntityId
              )
            }
          />
        </div>
        <img
          className='max-desktop-s:relative max-desktop-s:right-[-10px] max-desktop-s:bottom-[unset] max-desktop-s:object-contain max-tablet:hidden absolute right-[30px] bottom-[0px]'
          src={bannerImage}
          alt='banner image'
        />
      </div>
    </div>
  );
};
